/* Judge.me grid supplies 240px thumbnails without srcset. Request responsive
   renditions from the same image CDN, without changing the customer's photo. */
(() => {
  const upgradeImage = (image) => {
    if (!image.matches('.jdgm-review-card-media__image')) return;
    let url;
    try { url = new URL(image.getAttribute('src')); } catch { return; }
    if (url.hostname !== 'review-images.judgeme.com' || !url.searchParams.has('width')) return;
    const sizes = '(min-width: 750px) 208px, calc((100vw - 48px) / 2)';
    const srcset = [480, 720, 960].map(width => {
      url.searchParams.set('width', width);
      return `${url.href} ${width}w`;
    }).join(', ');
    if (image.sizes !== sizes) image.sizes = sizes;
    if (image.srcset !== srcset) image.srcset = srcset;
  };
  const setup = (root) => {
    if (root.dataset.imagesReady) return;
    root.dataset.imagesReady = 'true';
    root.querySelectorAll('img').forEach(upgradeImage);
    new MutationObserver(records => records.forEach(record => {
      if (record.type === 'attributes') upgradeImage(record.target);
      record.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches('img')) upgradeImage(node);
        node.querySelectorAll('img').forEach(upgradeImage);
      });
    })).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
  };
  document.querySelectorAll('.fp-pdp-community').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.fp-pdp-community').forEach(setup));
})();
